import { create } from 'zustand';

export const useNodeExportDownloads = create<{
  downloads: Map<string, { nodeName: string; controller: AbortController }>;
}>(() => ({
  downloads: new Map(),
}));

export async function trackNodeExportDownload(
  key: string,
  nodeName: string,
  download: (signal: AbortSignal) => Promise<void>,
) {
  const { downloads } = useNodeExportDownloads.getState();
  if (downloads.has(key)) return;
  const controller = new AbortController();
  useNodeExportDownloads.setState({ downloads: new Map(downloads).set(key, { nodeName, controller }) });
  try {
    await download(controller.signal);
  } catch (error) {
    if (!controller.signal.aborted) throw error;
  } finally {
    const current = useNodeExportDownloads.getState().downloads;
    if (current.get(key)?.controller === controller) {
      const next = new Map(current);
      next.delete(key);
      useNodeExportDownloads.setState({ downloads: next });
    }
  }
}

export function cancelNodeExportDownloads() {
  useNodeExportDownloads.getState().downloads.forEach(({ controller }) => controller.abort());
  useNodeExportDownloads.setState({ downloads: new Map() });
}
